module.exports = "<div class=\"row-fluid\">\r\n    <div class=\"list span8\">\r\n        <div class=\"toggle-all-faqs\">\r\n            <a href=\"#\" class=\"expand\">Expand All</a>\r\n            <span>|</span>\r\n            <a href=\"#\" class=\"collapse\">Collapse All</a>\r\n        </div>\r\n    </div>\r\n    <div class=\"toc span4\"></div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/faq/faqPageView.html
 ** module id = 41
 ** module chunks = 0
 **/